import type { FC, PropsWithChildren } from "react";
import { useParams } from "react-router-dom";
import PersonnelIdentityContext from "src/contexts/data/PersonnelIdentityContext";
import type { GetPersonnelIdentityByIdResponse } from "src/api/Tmd.dtos";
import usePersonnelIdentityById from "src/hooks/data/load/usePersonnelIdentityById";
import type { SWRConfiguration } from "swr";

interface IPersonnelProviderProps extends PropsWithChildren {
    id?: number;
    configuration?: SWRConfiguration<
        GetPersonnelIdentityByIdResponse,
        GetPersonnelIdentityByIdResponse
    >;
}

const PersonnelIdentityProvider: FC<IPersonnelProviderProps> = ({
    children,
    id,
    configuration,
}) => {
    const context = usePersonnelIdentityById(id, configuration);

    return (
        <PersonnelIdentityContext.Provider value={context}>
            {children}
        </PersonnelIdentityContext.Provider>
    );
};

export const RoutePersonnelIdentityProvider: FC<PropsWithChildren> = ({ children }) => {
    const { personnelId } = useParams<{ personnelId: string }>();
    const id = personnelId ? parseInt(personnelId, 10) : undefined;

    return <PersonnelIdentityProvider id={id}>{children}</PersonnelIdentityProvider>;
};

export default PersonnelIdentityProvider;
